import { ListItem, Box } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { TopNavigationConfig } from "../../configuration/navTopConfiguration";
import { NavbarDrawerContext, ThemeContext } from "../../root.component";
import { useContext } from "react";

export type NavTopMenuProps = {
  topNavigation: TopNavigationConfig;
};

export function NavTopMenu({ topNavigation }: NavTopMenuProps) {
  const {
    palette: {
      text: { primary: primaryMain },
      secondary: { main: secondaryMain },
    },
  } = useContext(ThemeContext);

  const { setDrawerState } = useContext(NavbarDrawerContext);

  const defineIsActiveStyle = (isActive: boolean) => {
    if (isActive) return isActive;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();
    const subRoutesToForceActive = ["/profile/badges"];

    const isInProfileParcel = topNavigation.url === "/profile";
    const isSubRouteForcedActivated = subRoutesToForceActive.some(
      (url) => pathname === url
    );
    const shouldActiveMyProfileNavLink =
      isInProfileParcel && isSubRouteForcedActivated;

    return shouldActiveMyProfileNavLink;
  };

  return (
    <ListItem key={topNavigation.id} sx={navTopMenuSx}>
      <NavLink
        onClick={() => setDrawerState(false)}
        to={topNavigation.url}
        style={({ isActive }) => ({
          ...navTopMenuLinkStyles,
          color: defineIsActiveStyle(isActive) ? secondaryMain : primaryMain,
        })}
        className={"nav-menu-item"}
        end={topNavigation.exactUrl}
      >
        <Box sx={iconContainerSx}>
          <i className={topNavigation.icon} />
        </Box>
        {topNavigation.label}
      </NavLink>
    </ListItem>
  );
}

const navTopMenuSx = {
  padding: "8px",
  margin: "24px 32px 0px",
  "&:first-of-type": {
    marginTop: 0,
  },
};

const navTopMenuLinkStyles = {
  fontWeight: 600,
  textDecoration: "none",
  display: "flex",
  gap: "8px",
  color: "#000",
};

const iconContainerSx = {
  display: "flex",
  alignItems: "center",
  fontWeight: 500,
};
